import { render, staticRenderFns } from "./ProgDepartment.vue?vue&type=template&id=1bf81aaa"
import script from "./ProgDepartment.vue?vue&type=script&lang=js"
export * from "./ProgDepartment.vue?vue&type=script&lang=js"
import style0 from "./ProgDepartment.vue?vue&type=style&index=0&id=1bf81aaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports